import * as vp from 'vopay';

type AddSignerRows = {
  label: vp.AddSignerLabel;
  id: vp.AddSignerId;
  require: boolean;
  preset: keyof vp.TextFieldPresets | undefined;
};

const buildAddSignerRows = (): AddSignerRows[] => [
  {
    label: vp.AddSignerLabel.AuthorizedFullLegalName,
    id: vp.AddSignerId.AuthorizedFullLegalName,
    require: true,
    preset: 'text',
  },
  {
    label: vp.AddSignerLabel.AuthorizedEmailAddress,
    id: vp.AddSignerId.AuthorizedEmailAddress,
    require: true,
    preset: 'text',
  },
  {
    label: vp.AddSignerLabel.AuthorizedOccupation,
    id: vp.AddSignerId.AuthorizedOccupation,
    require: true,
    preset: 'text',
  },
];

export default buildAddSignerRows;
